




























import { defineComponent, PropType } from '@vue/composition-api';
import { SelfBuildingSquareSpinner } from 'epic-spinners';
import { BlockchainMessage } from '../../constants';

export default defineComponent({
    name: 'LoadingModal',
    components: {
        SelfBuildingSquareSpinner,
    },
    props: {
        message: {
            type: String as PropType<BlockchainMessage>,
            required: false,
        },
    },
});
